module.exports = __webpack_public_path__ + "static/media/c47.2f07c287.png";